import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material';
import { Usuario } from 'src/app/models/usuario';
import { UsuarioService } from 'src/app/services/usuario/usuario.service';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { URL_SERVICIOS } from 'src/app/config/config';

@Component({
  selector: 'app-capturalander',
  templateUrl: './capturalander.component.html',
  styleUrls: ['./capturalander.component.css']
})
export class CapturalanderComponent implements OnInit {
  form: FormGroup;
  bactivapasswords = false;
  etiquetapassword = 'Change Password';
  colorcambiante = '';
  seccion = '';
  seccionsmx = true;
  archivoSonido: File = null;
  sonidoActual = '';
  restaurarSonido = false;

  constructor(
    public usuarioService: UsuarioService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<CapturalanderComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.buildForm();
   }

  ngOnInit() {
     this.sonidoActual = this.data.identificador.sonidoNotificacion || '';
     const valorpagina = localStorage.getItem('pagina');
     if (valorpagina === 'landing') {
      this.seccion = 'USER_LANDING';
      this.seccionsmx = false;
      // this.element = document.getElementById('rolusuario') as HTMLElement;
      // this.element
    }

  }


  activapasswords(){

    if (this.bactivapasswords) {
      this.etiquetapassword = 'no cambiar password';
      this.bactivapasswords = false ;
    } else {
      this.bactivapasswords = true ;
    }
  }



  private buildFormclear() {
    this.form =  this.formBuilder.group({
      nombrecliente: ['', [Validators.required]],
      apellido: ['', [Validators.required]],
      alias: ['', [Validators.required]],
      emailpersonal: ['', [Validators.required, Validators.email]],
      role: ['', [Validators.required]],
      activado: ['', [Validators.required]],
 _idusuario: [''], // este campo que e sla claave del registro se usara para saber si es edicion o agrega nuevo
      _idempresa: [''],
      color:  [''],
      contrasena: null,
      contrasena2: null,
      dirigido:  [''],

    });
  }


  private buildForm() {
    this.form =  this.formBuilder.group({
      nombrecliente: [this.data.identificador.nombrecliente, [Validators.required]],
      apellido: [this.data.identificador.apellido, [Validators.required]],
      alias: [this.data.identificador.alias, [Validators.required]],
      emailpersonal: [this.data.identificador.emailpersonal, [Validators.required, Validators.email]],
      role: [this.data.identificador.role, [Validators.required]],
      activado: [this.data.identificador.activado],
 _idusuario: [this.data.identificador._id], // este campo que e sla claave del registro se usara para saber si es edicion o agrega nuevo
      _idempresa: [this.data.identificador.idempresa._id],
      color:  [this.data.identificador.color],
      contrasena: null,
      contrasena2: null,
      dirigido:[this.data.identificador.dirigido],

    });
  }






  save(event: Event) {


    event.preventDefault();
    if (this.form.valid) {
       const value = this.form.value;


       const usuario = new Usuario(
         this.form.value.nombrecliente,
         this.form.value.apellido,
         this.form.value.emailpersonal,
         this.form.value.dirigido,
         this.form.value.activado,
         null,
         this.data.identificador.idempresa._id,
         false,
         this.form.value.role,
         this.form.value.color,
         this.form.value.alias
       );


       console.log (usuario);



       if  (this.form.value._idusuario === null) {
         alert ('agregar');

         this.usuarioService.altadeusuarios( usuario )
        .subscribe ( resp => {
          console.log ('se agrego');
        });

       } else {
       // si encuentra en el text _id  informacion quiee decir que es edicion

          // alert ('edicion');
            this.usuarioService.actualizaUsuarios( usuario, this.form.value._idusuario )
        .subscribe ( resp => {
          this.guardarSonidoUsuario();

        });

      //     this.empresaService.modificaempresausuario( empresa, this.form.value._idusuario )
  //   .subscribe ( resp => {
       // this.router.navigate(['login/login']);
     // console.log ('registrado');
   //  });

       }


    } else {
      alert ('invalido');
      this.form.markAllAsTouched();
    }

     }

     seleccionaSonido(event) {
       const archivo = event.target.files && event.target.files[0];

       if (!archivo) {
         return;
       }

       if (archivo.name.toLowerCase().slice(-4) !== '.mp3') {
         alert('Seleccione un archivo MP3');
         event.target.value = '';
         return;
       }

       if (archivo.size > 5 * 1024 * 1024) {
         alert('El archivo MP3 no debe superar 5 MB');
         event.target.value = '';
         return;
       }

       this.archivoSonido = archivo;
       this.restaurarSonido = false;
     }

     probarSonido() {
       let url = '/assets/sound/notification.mp3';

       if (this.archivoSonido) {
         url = URL.createObjectURL(this.archivoSonido);
       } else if (this.sonidoActual) {
         url = URL_SERVICIOS + '/' + this.sonidoActual;
       }

       const audio = new Audio(url);
       audio.play().catch(() => alert('No fue posible reproducir el sonido'));
     }

     usarSonidoPredeterminado() {
       this.archivoSonido = null;
       this.restaurarSonido = true;
     }

     guardarSonidoUsuario() {
       const idUsuario = this.form.value._idusuario;

       if (this.archivoSonido) {
         this.usuarioService.guardaSonidoNotificacion(idUsuario, this.archivoSonido)
           .subscribe(resp => {
             this.sonidoActual = resp.sonidoNotificacion || '';
             this.actualizaSonidoSesionActual(idUsuario, this.sonidoActual);
             this.archivoSonido = null;
             this.restaurarSonido = false;
             alert('Usuario y sonido guardados correctamente');
           }, error => alert(error.error && error.error.mensaje ? error.error.mensaje : 'No fue posible guardar el sonido'));
         return;
       }

       if (this.restaurarSonido) {
         this.usuarioService.restauraSonidoNotificacion(idUsuario)
           .subscribe(() => {
             this.sonidoActual = '';
             this.actualizaSonidoSesionActual(idUsuario, '');
             this.restaurarSonido = false;
             alert('Se restauro el sonido predeterminado');
           }, error => alert(error.error && error.error.mensaje ? error.error.mensaje : 'No fue posible restaurar el sonido'));
         return;
       }

       alert('Usuario guardado correctamente');
     }

     actualizaSonidoSesionActual(idUsuario: string, sonidoNotificacion: string) {
       if (localStorage.getItem('iduser') !== idUsuario) {
         return;
       }

       const usuarioGuardado = localStorage.getItem('usuario');
       if (!usuarioGuardado) {
         return;
       }

       const usuario = JSON.parse(usuarioGuardado);
       usuario.sonidoNotificacion = sonidoNotificacion;
       localStorage.setItem('usuario', JSON.stringify(usuario));
     }

     closeDialog() {
     this.dialogRef.close();

     }



     sonIguales( campo1: string, campo2: string) {
      return (group: FormGroup) => {

        const pass1 = group.controls[campo1].value;
        const pass2 = group.controls[campo2].value;

        if ( pass1 === pass2 ) {
          return null;
        }

        return {
          sonIguales: true
        };
      };
    }


    nuevoRegistro() {
      this.form.reset();
      this.bactivapasswords = true;

    }


}
